import { useState } from "react";
import {
  Badge,
  Button,
  Card,
  Col,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import useRedirect from "../../../../components/custom-hooks/use-redirect";
import { findIcon } from "../../../dashboard/icons";
import ActionButtonBar from "../../../../components/partials/common/action-button-bar";
import ReactTable from "../../../../lib/table/react-table";
import { useInfiniteProjectPostList } from "../../../../queries/query-hooks/workspace/workspace-hook";
import PageNotFound from "../../../PageNotFound";
import ChannelListSkeleton from "./../../../../skeleton/workspace/doctube/channel/channel-list-skeleton";
import ProjectCard from "./channel/components/card/ProjectCard";
import { getFormatedDate } from "../../../../common/utils/utils";
import { useDispatch, useSelector } from "react-redux";
import * as authSelectors from "../../../../store/auth/selectors";
import { updateProject } from "../../../../store/project/project.action";
import InfiniteScroll from "react-infinite-scroll-component";
import ProjectFilter from "./ProjectFilter";
import { isMobileOnly } from "react-device-detect";
import { selectedFilters } from "../../../../store/common/selectors";
import { updateFilters } from "../../../../store/common/actions";

export default function Workspacelist({ id }) {
  const user = useSelector(authSelectors.user);
  const filters = useSelector(selectedFilters);
  const [show, setShow] = useState(false);
  const [filterState, setFilterState] = useState({});
  const {
    data: channels,
    fetchNextPage,
    hasNextPage,
    isLoading: isChannelLoading,
  } = useInfiniteProjectPostList(id, {
    default: "all",
    pagination: {
      limit: 10,
      offset: 0,
    },
    filter: filters,
    sort: {
      project_start_date: "DESC",
      id: "DESC",
    },
  });

  const [isListView, setIsListView] = useState(false);
  const { redirectTo } = useRedirect();
  const dispatch = useDispatch();
  const allChannels = channels?.pages.flatMap((page) => page.data || []);

  const channelColumns = [
    {
      Header: "Project Logo",
      accessor: "project_logo",
      columnId: 1,
      disableFilters: true,
      disableSortBy: true,
      Cell: ({ value, row }) => {
        return (
          <img
            className="rounded-3 border border-1 icon-60 object-fit-contain rounded-circle p-1"
            src={row?.original?.project_logo}
          />
        );
      },
    },
    {
      Header: "Project Name",
      accessor: "project_name",
      columnId: 2,
      disableFilters: true,
    },
    {
      Header: "Project Type",
      accessor: "project_type_name",
      columnId: 3,
      disableFilters: true,
      Cell: ({ value }) => {
        return "Doctube";
      },
    },
    {
      Header: "Updated On",
      accessor: "updated_at",
      disableFilters: true,
      columnId: 4,
      Cell: ({ row }) => {
        return getFormatedDate(row?.original?.updated_at);
      },
    },
    {
      columnId: 5,
      Header: "Action",
      accessor: "action",
      disableFilters: true,
      disableSortBy: true,
      Cell: ({ row, value }) =>
        row?.content_id == 0 ? (
          <></>
        ) : (
          <ActionButtonBar
            buttons={["select"]}
            row={row}
            onSelect={(data) => {
              const updatedProjectData = {
                project_id: data?.id,
                title: data?.project_name,
                projectType: data?.project_type_info[0]?.project_type_name,
                projectTypeCode: data?.project_type_info[0]?.project_type_code,
                updateDate: data?.updated_at,
                channel_logo: data?.project_logo,
                start_date: data?.project_start_date,
                end_date: data?.project_end_date,
              };

              dispatch(updateProject(updatedProjectData));
              redirectTo(`project/channels`);
            }}
            // onEdit={(data) => {
            //   redirectTo(`workspace/project-details/${data?.content_id}`);
            // }}
          />
        ),
    },
  ];

  const projectColumns = [
    {
      Header: "Project Logo",
      accessor: "project_logo",
      columnId: 1,
      disableFilters: true,
      Cell: ({ value, row }) => {
        return (
          <img
            className="rounded-3 border border-1 icon-60 object-fit-contain rounded-circle p-1"
            src={row.original?.project_logo}
          />
        );
      },
    },
    {
      Header: "Project Name",
      accessor: "project_name",
      columnId: 2,
      disableFilters: true,
    },
    {
      Header: "Project Type",
      accessor: "project_type_info",
      columnId: 3,
      disableFilters: true,
      Cell: ({ value }) => {
        return value[0]?.project_type_name;
      },
    },
    {
      Header: "Updated on",
      columnId: 4,
      disableFilters: true,
      Cell: ({ row }) => {
        return getFormatedDate(row.original?.updated_at);
      },
    },
    {
      Header: "Status",
      accessor: "project_status",
      columnId: 4,
      disableFilters: true,
      Cell: ({ value }) => {
        if (value == 1) return "Enabled";
        return "Disabled";
      },
    },
    {
      columnId: 5,
      Header: "Action",
      accessor: "id",
      disableFilters: true,
      Cell: ({ row, value }) => {
        const isDisabled = row?.original?.project_status === 2;
        return (
          <ActionButtonBar
            buttons={`${isDisabled ? ["disabled"] : ["select"]}`}
            row={row}
            onSelect={(data) => {
              const projectTypeMap = {
                brand_ads: "brand-ads",
                sponsored_content: "sponsored-content",
                events: "events",
                emsl: "emsl",
                clirnet_channel: "sponsored-community",
              };

              const updatedProjectData = {
                project_id: data?.id,
                title: data?.project_name,
                projectType: data?.project_type_info[0]?.project_type_name,
                projectTypeCode: data?.project_type_info[0]?.project_type_code,
                updateDate: data?.updated_at,
                channel_logo: data?.project_logo,
                start_date: data?.project_start_date,
                end_date: data?.project_end_date,
              };

              dispatch(updateProject(updatedProjectData));

              const projectTypeTemp =
                data?.project_type_info?.[0]?.project_type_code;
              const projectType =
                projectTypeMap[projectTypeTemp] || "brand-ads";

              if (isDisabled) return;

              if (projectType === "emsl") {
                redirectTo(`${projectType}/summary/engaged-hcps/${data?.id}`);
              } else if (projectType === "sponsored-community") {
                redirectTo(`${projectType}/dashboard/${data?.id}`);
              } else {
                redirectTo(`${projectType}/summary/${data?.id}`);
              }
            }}
          />
        );
      },
    },
  ];

  const isUserHasProjectCreatePermission = user?.user_has_permissions?.some(
    (item) => item?.name === "create_project"
  );

  const handleFilterSubmit = (filterData) => {
    const rawPayload = {
      project_name: filterData.project_name
        ? { type: "like", value: filterData.project_name }
        : null,
      tag: filterData.tag ? { field: "label", value: filterData.tag } : null,
      project_type_id: filterData.project_type_id
        ? { type: "eq", value: filterData.project_type_id }
        : null,
      project_status: filterData.project_status
        ? { type: "eq", value: filterData.project_status }
        : null,
    };

    const payloadFilter = Object.fromEntries(
      Object.entries(rawPayload).filter(([_, val]) => val !== null)
    );

    setFilterState(payloadFilter);
    dispatch(updateFilters(payloadFilter));
  };

  const handleRemoveFilter = (keyToRemove) => {
    const updatedFilter = { ...filters };
    delete updatedFilter[keyToRemove];
    setFilterState(updatedFilter);
    dispatch(updateFilters(updatedFilter));
  };

  const projectFilterKeys = {
    project_name: "project name",
    tag: "tag",
    project_status: "project status",
    project_type_id: "project type",
  };
  const projectStatusValue = {
    1: "Enabled",
    2: "Disabled",
  };
  const projectTypeValue = {
    1: "DocTube Channel",
    2: "Sponsored Content",
    3: "Brand Ads",
    4: "eMSL",
    5: "Events",
    6: "VRTMs",
    7: "Ad Boards",
    8: "CLIRNET Channel",
    9: "IEM",
    10: "Survey/Poll",
  };
  const graphTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Projects arranged by newest
    </Tooltip>
  );
  return (
    <>
      <div>
        <div className="d-flex justify-content-between align-items-md-center flex-sm-row flex-column flex-wrap mb-4 gap-2 gap-md-3">
          <div className="d-flex align-items-center gap-2">
            <h4 className="m-0 fw-semibold">All Projects</h4>
            <OverlayTrigger
              placement="right"
              delay={{ show: 50, hide: 200 }}
              overlay={graphTooltip}
            >
              <span className="text-primary cursor-pointer">
                {findIcon("info", "outline", 20)}
              </span>
            </OverlayTrigger>
          </div>

          <div className="d-flex gap-2 align-items-center">
            <ul
              className="nav nav-pills mb-0 iq-product-filter d-flex bg-transparent align-items-center flex-nowrap me-md-3 gap-2 flex-row"
              id="pills-tab"
              role="tablist"
            >
              <li
                className="nav-item"
                role="presentation"
                title="Grid View"
                onClick={() => setIsListView(false)}
              >
                <Button
                  bsPrefix={
                    "nav-link btn-sm btn-icon rounded-pill" +
                    (isListView ? "" : " active")
                  }
                  id="grid-view-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-grid-view"
                  to="#"
                  role="tab"
                  aria-controls="pills-grid-view"
                  aria-selected="true"
                >
                  <span className="btn-inner d-inline-flex">
                    {findIcon("View Grid", "dual-tone")}
                  </span>
                </Button>
              </li>
              <li
                className="nav-item"
                role="presentation"
                title="List View"
                onClick={() => setIsListView(true)}
              >
                <Button
                  bsPrefix={
                    "nav-link btn-sm btn-icon rounded-pill" +
                    (isListView ? " active" : "")
                  }
                  id="list-view-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-list-view"
                  to="#"
                  role="tab"
                  aria-controls="pills-list-view"
                  aria-selected="false"
                >
                  <span className="btn-inner d-inline-flex">
                    {findIcon("Rows", "dual-tone")}
                  </span>
                </Button>
              </li>
            </ul>

            <Button
              variant="soft-primary"
              className={`d-flex align-items-center gap-2 ms-auto ms-md-0 ${
                isMobileOnly ? "btn-icon" : ""
              }`}
              onClick={() => {
                setShow(true);
              }}
            >
              {findIcon("Filter", "dual-tone", 18)}
              <span className="d-none d-lg-block">Show Filters</span>
            </Button>

            {isUserHasProjectCreatePermission ? (
              <Button
                variant="primary"
                className="d-flex align-items-center gap-2 text-nowrap"
                onClick={() => redirectTo("workspace/create-project")}
              >
                {findIcon("Plus", "solid", 18)}
                Create Project
              </Button>
            ) : null}
          </div>
        </div>
        {Object.entries(filters)?.length > 0 ? (
          <div className="d-flex flex-row flex-nowrap align-items-center gap-2 overflow-auto mb-3">
            {Object.entries(filters).map(([key, value]) => (
              <Badge
                bg="soft-secondary"
                className="d-flex d-flex align-items-center gap-2 px-3 py-2 rounded-pill"
                key={`${key}-${value}`}
              >
                <span className="text-capitalize poppins-medium text-secondary fs-6">
                  {`${projectFilterKeys[key] || key}: `}
                </span>
                <span className="poppins-medium text-black fs-6">
                  {key === "project_status"
                    ? projectStatusValue[value.value] || value.value
                    : key === "project_type_id"
                    ? projectTypeValue[value.value] || value.value
                    : value.value}
                </span>
                <div
                  className="cursor-pointer rounded-circle text-secondary btn-close"
                  onClick={() => handleRemoveFilter(key)}
                ></div>
              </Badge>
            ))}
          </div>
        ) : null}
      </div>
      {!isChannelLoading && allChannels?.length > 0 ? (
        <Row>
          {allChannels?.length > 0 && isListView && (
            <Card>
              <Card.Body>
                {id == 1 && (
                  <ReactTable
                    data={allChannels}
                    columns={channelColumns}
                    isPaginationShow={false}
                    recordsPerPage={10}
                    borderBottom
                  />
                )}

                {id == 2 && (
                  <ReactTable
                    data={allChannels}
                    columns={projectColumns}
                    isPaginationShow={false}
                    recordsPerPage={10}
                    borderBottom
                  />
                )}
              </Card.Body>
            </Card>
          )}

          {allChannels?.length > 0 && !isListView ? (
            <InfiniteScroll
              dataLength={allChannels.length}
              next={fetchNextPage}
              hasMore={hasNextPage}
              loader={<p className="text-center">Loading...</p>}
              className="row"
            >
              {allChannels.map((data, key) => {
                const projectTags = data?.project_attributes?.find(
                  (item) => item?.attribute_name === "tags"
                )?.attribute_value;

                const projectTagsArray = projectTags
                  ? JSON.parse(projectTags)
                  : [];

                return (
                  <Col className="d-flex" sm={6} md={4} lg={4} key={key}>
                    <ProjectCard
                      project_id={data?.id}
                      title={data?.project_name}
                      projectType={
                        data?.project_type_info[0]?.project_type_name
                      }
                      projectTypeCode={
                        data?.project_type_info[0]?.project_type_code
                      }
                      startDate={data?.project_start_date}
                      endDate={data?.project_end_date}
                      updateDate={data?.updated_at}
                      channel_logo={data?.project_logo}
                      tags={projectTagsArray}
                      projectTypeId={data?.project_type_id}
                      projectStatus={data?.project_status}
                    ></ProjectCard>
                  </Col>
                );
              })}
            </InfiniteScroll>
          ) : null}
        </Row>
      ) : isChannelLoading ? (
        <ChannelListSkeleton />
      ) : (
        <PageNotFound
          title="You do not have any project yet"
          backgroundImage={findIcon("Support-ticket", "dual-tone", 100)}
          message="please contact support team"
          buttonText="Raise support ticket"
          onFallbackClick={() => {
            redirectTo(`help-and-support/raise-support-ticket`);
          }}
        />
      )}

      <ProjectFilter
        show={show}
        setShow={setShow}
        handleFilterSubmit={handleFilterSubmit}
        setFilterState={setFilterState}
        projectMasterType={id === 1 ? "doctube" : "clirnet"}
      />
    </>
  );
}
